import {
  getStatusColor,
  ChipButtonMenuProps,
  WARNING_DAYS,
} from '@centerpiece/components';
import moment from 'moment';

// type Status = 'ontrack' | 'complete' | 'warning' | 'pastdue' | 'default';
// export const getStatusFromDate = (date?: string): Status => {
//   if (date) {
//     let days = moment(date).diff(moment.now(), 'days');
//     return days <= WARNING_DAYS
//       ? days < 0
//         ? 'pastdue'
//         : 'warning'
//       : 'ontrack';
//   }
//   return 'default';
// };

export const getCalendarTypeFromDate = (
  date?: string | Date | null
): string => {
  if (date) {
    let days = moment(date).diff(moment.now(), 'days');
    return days <= WARNING_DAYS ? (days < 0 ? 'error' : 'warning') : 'success';
  }
  return 'default';
};

export const getStatusColorFromDate = (date?: string) => {
  let status;
  if (date) {
    let days = moment(date).diff(moment.now(), 'days');
    status =
      days <= WARNING_DAYS ? (days < 0 ? 'pastdue' : 'warning') : 'ontrack';
  }
  return getStatusColor(status);
};

export interface ItemStatus {
  id: number;
  name: string;
}

export interface ItemStatusProps {
  status: ItemStatus;
  color?: string; //"inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning" | undefined,
  statuses: ItemStatus[];
  disabled?: boolean;
  onClick: (status: ItemStatus) => void;
}

export const getItemStatus = ({
  status,
  disabled = false,
  color,
  statuses,
  onClick,
}: ItemStatusProps): ChipButtonMenuProps => {
  return {
    label: status?.name,
    color: color || 'inherit',
    disabled: disabled,
    menuItems: statuses?.map(status => ({
      label: status?.name,
      onClick: () => onClick(status),
    })),
  };
};
